import url from './url';
import request from './request';

export const getUserPermissions = (email) =>
  request(`${url.permissions}/${email}`);
